export class ProspectStatisticRequest {
  userId?: number;
  fromDate?: number;
  toDate?: number;
  statisticType?: string;
  multipleUser?: number[];
}
